enum PRIMARY_SIGNUP_REQUIREMENT {
    PRIMARY_JOB = 'primary_job',
    PAY_CYCLE = 'pay_cycle',
    ESTIMATED_NET_PAY = 'estimated_net_pay',
}

export enum SECONDARY_SIGNUP_REQUIREMENT {
    PASSWORD_SET = 'password_set',
    VERIFIED_PHONE = 'verified_phone',
}

export enum PHO_FLOW {
    CARD = 'card_pho_submit_application',
    MARKETPLACE = 'mp_pho_submit_application',
    PAYCHEX = 'paychex_pho_submit_application',
}

export type SignupRequirementsData = {
    continuePhoFlow: PHO_FLOW;
    latestPhoFlow: PHO_FLOW;
    requirements: {
        primary: PRIMARY_SIGNUP_REQUIREMENT[];
        secondary: SECONDARY_SIGNUP_REQUIREMENT[];
    };
};
